import {guard} from "./helper";
import ManageCards from "../views/manageCards/ManageCards";
import AddCredit from "../views/manageCards/AddCredit";
import AddGift from "../views/manageCards/AddGift";
import EditGiftCard from "../views/manageCards/EditGiftCard";
import MemberBarCode from "../views/manageCards/MemberBarCode";
export default [
    {
        path: '/ManageCards',
        name: 'ManageCards',
        beforeEnter: guard,
        component: ManageCards
    },
    {
        path: '/addcard',
        name: 'AddCredit',
        component: AddCredit
    },
    {
        path: '/addgiftcard',
        name: 'AddGift',
        component: AddGift
    },
    {
        path: '/editgiftcard/:cardId',
        name: 'EditGiftCard',
        beforeEnter: guard,
        component: EditGiftCard
    },
    {
        path: '/scanbarcode',
        name: 'MemberBarCode',
        beforeEnter: guard,
        component: MemberBarCode
    }
]
